<div>
  <kl-bulk-members-addition (loginIdsList)="addBulkMembers($event)"  ></kl-bulk-members-addition>
</div>
